import React, { useState, useEffect, useContext, useRef, useMemo } from 'react';
import clsx from 'clsx';
import { useElementSize } from 'lib/hook';
import Icon from 'component/icon';
import { TableContext } from './context';

const Cell = (props) => {
    const { width, col, row, rowIndex, bgHover, bgSelected } = props;
    const { cellEllipsis, rowKey, selectedRow } = useContext(TableContext);

    const content = useMemo(() => {
        let text = row[col.dataIndex];
        if (col.render) {
            text = col.render(text, row, rowIndex);
        } else if (col.filterRender) {
            text = col.filterRender(text, row, rowIndex);
        } else if (typeof text === 'object' && text) {
            text = JSON.stringify(text);
        }
        return text;
    }, [col, row, rowIndex]);

    const ref = useRef();
    const [showEllipsis, setShowEllipsis] = useState(false);
    const ellipsisRowSelected = cellEllipsis && selectedRow && selectedRow === row[rowKey];
    const { width: textWidth } = useElementSize(ref);
    useEffect(() => {
        setShowEllipsis(textWidth > width - 1);
    }, [width, textWidth]);

    return col.render ? content : (
        <>
            <div
                ref={ref}
                className={clsx(
                    'overflow-hidden',
                    { 'w-fit whitespace-nowrap': !ellipsisRowSelected },
                    {
                        'text-center': ellipsisRowSelected &&
                            col.align !== 'left' && col.align !== 'right'
                    },
                    { 'text-left': ellipsisRowSelected && col.align === 'left' },
                    { 'text-right': ellipsisRowSelected && col.align === 'right' }
                )}
                style={{ width: width - 1 }}
            >
                {content}
            </div>
            {cellEllipsis && showEllipsis && !ellipsisRowSelected && (
                <div
                    className={clsx(
                        'absolute right-0 px-1',
                        { 'bg-table-row dark:bg-black-light02': !bgHover && !bgSelected },
                        { 'bg-table-row-hover dark:text-black': bgHover },
                        { 'bg-table-row-selected dark:text-black': bgSelected }
                    )}
                >
                    <Icon name="more_horiz" />
                </div>
            )}
        </>
    );
};

export default Cell;
